<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>{{ title }}</template>

    <Sheet.Body
      class="px-[30px]! pt-5 pb-[calc(env(safe-area-inset-bottom)+20px)]!"
    >
      <DacrMembershipBody />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import { useBillingStore } from '@/features/billing/store'
import DacrMembershipBody from './DacrMembershipBody.vue'

const { close } = useSheet()
const billingStore = useBillingStore()
const title = computed(() =>
  billingStore.isBasicMembership
    ? 'Dacr Basic Membership'
    : 'Dacr Pro Membership'
)
</script>
